import commonStyles from "../../common/css/Common.module.css";
const CcBtn = ({children, addClass, title, onClick}) => {
    return (
            <button type="button" onClick={onClick} className={`${commonStyles.cc_btn} ${addClass}`} title={title}>
                {children}
            </button>
    );
};

export default CcBtn;